import colorPattern from '../../../DesignSystem/colors'

const darkIconColors = {
    'icon-primary': colorPattern.pearl,
    'icon-secondary': colorPattern.moon,
    'icon-invert': colorPattern.onyx,
    'icon-brand-primary': colorPattern.sky,
    'icon-brand-secondary': colorPattern.violet,
    'icon-league-qualifier': colorPattern.yellow,
} as const

export default darkIconColors
